import {useNavigate, useLocation} from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import AdjustRoundedIcon from '@mui/icons-material/AdjustRounded';
import { useAuthDispatch, useAuthStore } from '../../../contexts/AuthContext';
import { theme } from '../../../components/muiTheme';
import { useMemo } from 'react';

export default function GlobalAccountFilter() {
    const { user, selectedAccount } = useAuthStore();
    const authDispatch = useAuthDispatch();
    const navigate = useNavigate();
    const {pathname} = useLocation();

    function handleAccountChange(e, newValue) {
        if (newValue.length !== 0) {
            authDispatch({ type:'setSelectedAccount', payload: newValue });
            authDispatch({ type: 'setSelectedAccountPermissions' });
            if(pathname.split("/")[1] === "workspace"){//only changing to the account url when it is in workspace tab. do navigate in other tabs but only change the selected account as above
                navigate(`/workspace/${newValue.uniqueHash}`)
            }
            if (pathname.split("/")[1] === "user-management") {
              //only changing to the account url when it is in workspace tab. do navigate in other tabs but only change the selected account as above
              navigate(`/user-management/${newValue.uniqueHash}/${pathname.split("/")[3] }`);
            }
            if (pathname.split("/")[1] === "marketplace") {
              //only changing to the account url when it is in workspace tab. do navigate in other tabs but only change the selected account as above
              navigate(`/marketplace/${newValue.uniqueHash}/${pathname.split("/")[3] }`);
            }
        }
    }
    const sortedAccounts = useMemo(() => {
        return [...user.Accounts].sort((a, b) => {
            if (a.name === "Innovare") return -1;
            if (b.name === "Innovare") return 1;
            return a.name.localeCompare(b.name);
        });
    }, [user]);

    const accountFilterStyles
     = {
        borderRadius: '30px',
        cursor: 'pointer',
    }

    return (
      <Autocomplete
        disableClearable
        forcePopupIcon={false}
        openOnFocus
        size="small"
        options={sortedAccounts}
        value={selectedAccount}
        onChange={handleAccountChange}
        getOptionLabel={(Account) => Account.name}
        defaultValue={user.Accounts[0]}
        blurOnSelect
        isOptionEqualToValue={(option, value) => option.name === value?.name} // removes console warning
        componentsProps={{
          paper: {
            sx: {
              width: 140,
            },
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              backgroundColor: theme.palette.secondary.main,
              input: {
                color: theme.palette.white.main,
                fontFamily: theme.typography.fontFamily,
                padding: "3px",
                paddingLeft: "10px",
                textAlign: "center",
                cursor: "pointer",
              },
              "& .MuiOutlinedInput-root": {
                ...accountFilterStyles,
              },
              minWidth: "120px",
              ...accountFilterStyles,
            }}
          />
        )}
        renderOption={(props, option, { selected }) => (
          <ListItem
            {...props}
            component="li"
            key={`${option.name}-${option.name}`}>
            <AdjustRoundedIcon
              sx={{
                paddingRight: "5px",
              }}
            />
            <ListItemText
              primary={option.name}
              primaryTypographyProps={{
                fontFamily: theme.typography.fontFamily,
              }}
              sx={{
                padding: 0,
                margin: 0,
              }}
            />
          </ListItem>
        )}
      />
    );
}